import React, {Component} from 'react'
import ReactDOM from 'react-dom';
import deepEqual from 'deep-equal'
import LinkWithTooltip from '../../tooltip';

class Editor extends Component {

  /* componentDidUpdate(prevProps){

    if(!deepEqual(this.props, prevProps)){
      setTimeout(() => {
        this.initializeEditor(prevProps);
      })
    }
  } */

  componentWillReceiveProps(nextProps){

    var formNode = ReactDOM.findDOMNode(this.refs.richEditor),
        editorId = jQuery(formNode).attr('id'),
        editor = tinyMCE.get(editorId);

    if(!deepEqual(editor.getContent(), nextProps.input.value)){
      editor.setContent(nextProps.input.value);
    }
  }

  componentDidMount(){
    this.initializeEditor(this.props);
  }


  initializeEditor(props){
    const { input: { value, onChange, name }, change } = props

    var formNode = ReactDOM.findDOMNode(this.refs.richEditor),
        editorId = jQuery(formNode).attr('id');

    if (typeof WFEditor == 'undefined') {

      tinyMCE.execCommand("mceRemoveEditor", true, editorId);

      /* TinyMCE Editor */
      tinymce.init({
        force_br_newlines : true,
        force_p_newlines : false,
        forced_root_block : '',
        toolbar_items_size: "small",
        invalid_elements : "script,applet",
        content_css : "administrator/components/com_sppagebuilder/assets/css/tinymce.css",
        theme: 'modern',
        menubar: false,
        height: '200',
        plugins: [
          "advlist autolink lists link charmap preview image",
          "searchreplace code fullscreen",
          "media contextmenu paste"
        ],
        content_style: "body{ font-size: 12px !important; }",
        relative_urls : true,
        document_base_url : pagebuilder_base,
        image_class_list: [
          {title: 'None', value: ''},
          {title: 'Left', value: 'pull-left'},
          {title: 'Right', value: 'pull-right'}
        ],
        toolbar: "styleselect | bold italic fontsizeselect | alignleft aligncenter alignright alignjustify | blockquote | bullist numlist | link image fullscreen | code",
        setup : function(ed){
          ed.on('change keyup paste SetContent', function(e){

            onChange(ed.getContent());
          });
        }
      });

      tinymce.execCommand('mceAddEditor', true, editorId);
    } else {
      /* JCE Editor */
      jQuery.extend(WFEditor.settings,{
        height: '200',
        setup: function(ed){
          var changeJCE = () => {
            onChange(ed.getContent());
          }
          ed.onNodeChange.add(changeJCE);
          ed.onChange.add(changeJCE);
          ed.onKeyUp.add(changeJCE);
          ed.onPaste.add(changeJCE);
          ed.onSetContent.add(changeJCE);
        }
      });

      WFEditor.create(editorId);
    }
  }

  render(){
    const { input, params } = this.props

    return (
      <div className="sp-pagebuilder-form-group">
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>
        <div className="content-editor" ref="editor">
          <textarea {...input} ref="richEditor" className="mce_editable wf-editor" id={input.name}></textarea>
        </div>

      </div>
    );
  }
}

export default Editor;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Editor.js